export enum FitEnum{
    STANDARD='STANDARD',
    LOOSEFIT = 'LOOSE FIT',
    OVERSIZED_FIT = "OVER SIZED FIT",
    DRIFIT = "DRI FIT"
}